module.exports = __webpack_public_path__ + "images/thumb-ab38700be78fc86b5e98b88e082ad126.jpg";